import BaseLayout from "../../layouts/BaseLayout";
import { useState, useEffect } from "react";
import { VojomoLoader } from "@vojomo-core/shared";
import { Link } from "react-router-dom";
import { apiRequest } from "@vojomo-core/shared";

export function Members(): React.ReactElement {
  const [members, setMembers] = useState([]); // Use state for members
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      const members: any = await apiRequest({
        subRoute: "utils",
        path: "/members"
      });

      setMembers(members);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  let content = null;

  if (isLoading) {
    content = <VojomoLoader />;
  } else {
    content = (
      <div className="h-[90vh] max-h-[90vh] overflow-y-scroll">
        <h3>Current Members</h3>

        <p className="text-sm italic">
          Want to create a new member company? Click{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://app.hubspot.com/contacts/46994075/objects/0-2/views/all/list"
          >
            here
          </a>{" "}
          to be directed to HubSpot. Click 'Create company' and make type
          'Member'.
        </p>

        {/* List members */}
        {members.map((member: { id: number; name: string }) => (
          <div key={member.id}>
            <Link to={`/members/${member.id}`}>{member.name}</Link>
            <br />
          </div>
        ))}
      </div>
    );
  }

  return <BaseLayout pageTitle="Members">{content}</BaseLayout>;
}
